import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment fullDealLocation on DealLocation {
    uuid
    dealUuid
    streetAddress
    city
    postCode
    countryCode
    lat
    lng
    merchantLocationUuid
  }
`

export default fragment
